import React, { MutableRefObject } from "react";

import { Card as AntCard, CardProps as AntCardProps } from "antd";

import { ProductEventProps, productAnalytics, trackMixpanel } from "utils";

export type CardProps = AntCardProps &
  ProductEventProps & {
    dataTestId?: string;
    mixpanelText?: string;
    customRef?: MutableRefObject<HTMLDivElement> | ((node?: Element | null) => void);
    border?: boolean;
  };

export const Card = ({
  children,
  onClick,
  dataTestId,
  mixpanelText,
  productEvent,
  productEventProperties,
  customRef,
  className,
  border,
  ...props
}: CardProps) => (
  <AntCard
    data-testid={dataTestId}
    className={`ant-card ${border ? "border" : ""} ${className ?? ""}`.trim()}
    onClick={(e) => {
      if (onClick) {
        trackMixpanel("ClickCard", { type: mixpanelText || "undefined" });
        if (productEvent) productAnalytics.track(productEvent, productEventProperties);
        onClick(e);
      }
    }}
    ref={customRef}
    {...props}
  >
    {children}
  </AntCard>
);

export default Card;
